angular.module("uib/template/progressbar/progress.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/progressbar/progress.html",
    "<div class=\"progress\" ng-transclude aria-labelledby=\"{{::title}}\"></div>");
}]);



// WEBPACK FOOTER //
// ./node_modules/angular-ui-bootstrap/template/progressbar/progress.html.js